export default "__VITE_ASSET__zkxvW6El__"